export enum SocialType {
    Twitter = 'twitter',
    Telegram = 'telegram',
    Discord = 'discord',
    TelegramCN = 'telegram_cn',
}

export enum SocialAuthCode {
    Success = 2000,
    UnknownError = 5000,
    TwitterError = 5001,
    InvalidQuery = 5002,
    UserNotExists = 5003,
    UserHasAssociatedWithTwitter = 5004,
    TwitterHasBeenUsed = 5005,
    TwitterCreatedTooShort = 5006,
    DiscordError = 5007,
    DiscordHasBeenUsed = 5008,
    UserHasAssociatedWithDiscord = 5009,
}

export const socialAuthStorageKey = (type: SocialType) => `one_piece_${type}_auth`;

export interface SocialAuthResult {
    code: number;
    stats?: unknown;
}
